export default __webpack_public_path__ + "static/media/Kotlin.37e6e4c8.svg";